import React, { useEffect, useState } from "react";
import { Alert, Checkbox, Modal, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { syncablePropertiesByGroup } from "constants/ProductSyncConstant";

const { Text } = Typography;

/**
 * Which properties this one link copies.
 *
 * Per link rather than one global setting: two shops can be the same product in the freezer and
 * a different product on the shelf. The physical facts are on by default and the commercial
 * ones are off, because the price is exactly the thing the two storefronts are allowed to
 * disagree about - but a pair that really is priced identically can say so here.
 *
 * Phase 1 only edits the Magazijn group; the others are listed so the choice is already made
 * when the rest of product management moves over.
 */
const SyncedPropertiesModal = ({ open, link, saving, onSave, onClose }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (!open) return;
    setSelected((link && link.syncedProperties) || []);
  }, [open, link]);

  return (
    <Modal
      open={open}
      width={620}
      title={t("product_data.synced_properties_title")}
      okText={t("save")}
      cancelText={t("cancel")}
      confirmLoading={saving}
      onOk={() => onSave(selected)}
      onCancel={onClose}
    >
      <p style={{ color: "#6b6b6b" }}>{t("product_data.synced_properties_description")}</p>

      {!!link && (
        <Text type="secondary">
          {t("product_data.synced_properties_link", {
            vce: link.vceName || link.vceProductId,
            hvo: link.hvoName || link.hvoProductId,
          })}
        </Text>
      )}

      <Checkbox.Group value={selected} onChange={setSelected} style={{ width: "100%", marginTop: 16 }}>
        {syncablePropertiesByGroup().map((group) => (
          <div key={group.group} style={{ marginBottom: 16 }}>
            <Text strong>{group.label}</Text>
            <Space direction="vertical" size={4} style={{ width: "100%", marginTop: 4 }}>
              {group.properties.map((property) => (
                <Checkbox key={property.key} value={property.key}>
                  {property.label}
                </Checkbox>
              ))}
            </Space>
          </div>
        ))}
      </Checkbox.Group>

      <Alert type="info" showIcon message={t("product_data.synced_properties_never")} />
    </Modal>
  );
};

export default SyncedPropertiesModal;
